import { skipToken, useQuery } from '@tanstack/react-query';

import { apiClient } from 'core/api/globals';

/**
 * Hook for fetching public study share data.
 * @param linkId - The ID of the share link to fetch. Can be null/undefined to support optional queries.
 * @returns Query result for the public study share data.  `null` indicates the share does not exist.
 */
export function useQueryStudySharePublic(linkId: string | null | undefined) {
  return useQuery({
    queryKey: ['study-share-public', linkId],
    queryFn: linkId == null ? skipToken : () => apiClient.studyShare.getStudySharePublic(linkId),
    staleTime: 1000 * 60 * 5, // 5 minutes cache
  });
}
